import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function LinearChart({ datasets }) {
  const labels = [
    "Jan.",
    "Feb.",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug.",
    "Sept.",
    "Oct.",
    "Nov.",
    "Dec.",
  ];

  const data = {
    labels,
    datasets,
  };

  const options = {
    hover: {
      mode: "dataset",
      intersect: true,
    },

    responsive: true,
    plugins: {
      title: {
        display: false,
        text: ''
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        }
      },
      y: {
        border: {
          display: false
        },
      }
    }
  }

  return <Line options={options} data={data} height={170} />;
}
